<template>
  <div class="col-sm-12 pers-offers-wrap pl0 carousel-pr-12 pr0">
    <h3 class="fs-14 bold lh20 mb8 ml12 rounded shimmer-container hide-shimmer-text" v-if="!onlyShowCard">
      Hi Pizza Lover, we have an offer for you
    </h3>
    <section class="carousel" dir="ltr" aria-label="Gallery">
      <div class="carousel__viewport">
        <ol
          class="carousel__track"
          style="transform: translateX(0px); transition: all 0ms ease 0s"
        >
          <li
            class="carousel__slide carousel__slide--active carousel__slide--visible"
            style="width: 57.1429%; order: 0"
          >
            <div class="pers-offer flex-row shimmer-container hide-shimmer-text" 
              style="width: 300px" 
              :style="{height : justShowCard && '56px'}" 
              :class="{'mb0':justShowCard}"
              >
              <div class="observer"></div>
              <div>
                <div class="fs-14 lh-20 bold offer-title disp-col-inline">
                  <span class="three-dot">Flat Rs.100 OFF</span>
                </div>
                <div class="fs-12 lh-18 offer-desc three-dot">
                  BIN coupon fully funded by bank
                </div>
              </div>
            </div>
          </li>
          <li
            class="carousel__slide carousel__slide--active carousel__slide--visible"
            style="width: 57.1429%; order: 0"
            v-if="!onlyShowCard"
          >
            <div class="pers-offer flex-row shimmer-container hide-shimmer-text" style="width: 300px">
              <div class="observer"></div>
              <div>
                <div class="fs-14 lh-20 bold offer-title disp-col-inline">
                  <span class="three-dot">Flat Rs.100 OFF</span>
                </div>
                <div class="fs-12 lh-18 offer-desc three-dot">
                  BIN coupon fully funded by bank
                </div>
              </div>
            </div>
          </li>
        </ol>
      </div>
    </section>
  </div>
</template>
<script>

export default {
  props: ["type" , "onlyShowCard"],
  data(){
    return {
      showExtraDiv : false,
      justShowCard : false,
    }
  }
  ,
  mounted(){
    if(this.type){
      this.showExtraDiv = true;
    }
    if(this.onlyShowCard){
      this.justShowCard = true;
    }
  }
}
</script>